// function cartFetchData(callback) {
//   jQuery.getJSON('/cart.js', callback);
// }

// function checkCartData() {
//   cartFetchData(dataCart => {

//         let goldQty = 0;
//         let hasFreeGold = false;

//         let cartItems = document.querySelectorAll('.cart__item');
//         let messageBox = document.querySelector('.buyMoreGetMoreText');

//         if (!cartItems.length || dataCart.item_count === 0) {
//             messageBox?.classList.add('hidden');
//             return;
//         }

//         cartItems.forEach(function(item){

//             let isGold = item.dataset.goldProduct === "true";
//             if(!isGold) return;

//             let qtyField = item.querySelector('.cart__quantity-field');
//             let qty = parseInt(qtyField.value) || 0;

//             goldQty += qty;

//             let priceText = item.querySelector('.cart__price ins')?.innerText.trim().toLowerCase();

//             if(priceText === "free" || priceText === "£0.00"){
//                 hasFreeGold = true;
//             }

//         });


//         // SPECIAL CASE
//         // only 1 gold item and it is free
//         if(goldQty === 1 && hasFreeGold){
//             messageBox.classList.add('hidden');
//             return;
//         }

//         // NORMAL ODD / EVEN LOGIC
//         if(goldQty % 2 === 1){
//             messageBox.classList.remove('hidden');
//         }else{
//             messageBox.classList.add('hidden');
//         }
//     });
// }

// document.addEventListener('click', () => setTimeout(checkCartData, 1500));
// document.addEventListener('keypress', () => setTimeout(checkCartData, 1500));

// // Initial run
// checkCartValue();


function cartFetchData(callback) {
  return jQuery.getJSON('/cart.js', callback);
}

// Keep static collection cards outside the live DOM until the native cart opens.
(function () {
  function cartDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function hydrateCartProducts(drawer) {
    if (!drawer) return;

    drawer.querySelectorAll('template[data-rg-cart-tab-products]').forEach(function (template) {
      var parent = template.parentNode;
      if (!parent) return;

      // Match the existing custom.js image setup for these late-inserted cards.
      (template.content || template).querySelectorAll('img').forEach(function (image) {
        image.setAttribute('draggable', false);
      });

      if (template.content) {
        parent.insertBefore(template.content, template);
      } else {
        // Older browsers expose template children directly instead of a fragment.
        while (template.firstChild) parent.insertBefore(template.firstChild, template);
      }
      parent.removeChild(template);
    });
  }

  function hydrateOpenCart() {
    var drawer = cartDrawer();
    if (drawer && (drawer.classList.contains('is-open') || (window.cart && window.cart.cartDrawerIsOpen))) {
      hydrateCartProducts(drawer);
    }
  }

  // The theme emits open before adding is-open and setting up its focus trap.
  document.addEventListener('theme:cart:open', function () {
    hydrateCartProducts(cartDrawer());
  });
  document.addEventListener('theme:cart:change', hydrateOpenCart);
  document.addEventListener('rebuy:cart.change', hydrateOpenCart);
  document.addEventListener('shopify:section:load', hydrateOpenCart);

  hydrateOpenCart();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateOpenCart, {once: true});
  }
})();

let goldCartCheckTimer;
let goldCartCheckRunning = false;
let goldCartCheckPending = false;

function scheduleGoldCartCheck() {
  if (goldCartCheckRunning) {
    goldCartCheckPending = true;
    return;
  }
  clearTimeout(goldCartCheckTimer);
  goldCartCheckTimer = setTimeout(checkCartData, 120);
}

function finishGoldCartCheck() {
  goldCartCheckRunning = false;
  if (goldCartCheckPending) {
    goldCartCheckPending = false;
    scheduleGoldCartCheck();
  }
}

function checkCartData() {
  clearTimeout(goldCartCheckTimer);
  if (goldCartCheckRunning) {
    goldCartCheckPending = true;
    return;
  }
  goldCartCheckRunning = true;

  cartFetchData().then(dataCart => {

    let goldQty = 0;
    let goldFree = false;

    let cartItems = document.querySelectorAll('.cart__item');

    let messageBox = document.querySelector('.buyMoreGetMoreText');
    let goldMessageSuccess = document.querySelector('.buyMoreGetMoreTextSuccess');
    let freeShippingMessage = document.querySelector('.drawer__message.free-shipping');

    /* ---------- EMPTY CART ---------- */
    if (dataCart.item_count === 0 || cartItems.length === 0) {
      messageBox?.classList.add('hide');
      goldMessageSuccess?.classList.add('hide');
      freeShippingMessage?.classList.remove('hide');
      return;
    }

    /* ---------- COUNT GOLD PRODUCTS ---------- */
    cartItems.forEach(item => {

      let isGold = item.dataset.goldProduct === "true";
      let qty = parseInt(item.querySelector('.cart__quantity-field')?.value) || 0;

      let priceText = item.querySelector('.cart__price ins')?.innerText.trim().toLowerCase();

      if (isGold) {
        goldQty += qty;

        if (priceText === "free" || priceText === "£0.00") {
          goldFree = true;
        }
      }

    });

    // /* ---------- BUY MORE MESSAGE ---------- */
    // if (goldQty % 2 === 1) {
    //   messageBox?.classList.remove('hide');
    // } else {
    //   messageBox?.classList.add('hide');
    // }

    // /* ---------- SUCCESS MESSAGE ---------- */
    // if (goldFree && goldQty % 2 === 0) {
    //   goldMessageSuccess?.classList.remove('hide');
    // } else {
    //   goldMessageSuccess?.classList.add('hide');
    // }

    // /* ---------- FREE SHIPPING MESSAGE ---------- */

    // // only gold items in cart
    // if (goldQty > 0 && dataCart.item_count === goldQty) {
    //   freeShippingMessage?.classList.add('hide');
    // } else {
    //   freeShippingMessage?.classList.remove('hide');
    // }

    if (goldQty === 1 && goldFree) {
      messageBox?.classList.add('hide');
      goldMessageSuccess?.classList.add('hide');
    } else {

      /* ---------- BUY MORE MESSAGE ---------- */
      if (goldQty % 2 === 1) {
        messageBox?.classList.remove('hide');
      } else {
        messageBox?.classList.add('hide');
      }

      /* ---------- SUCCESS MESSAGE ---------- */
      if (goldFree && goldQty % 2 === 0) {
        goldMessageSuccess?.classList.remove('hide');
      } else {
        goldMessageSuccess?.classList.add('hide');
      }
    }

    // only gold items in cart
    if (goldQty > 0 && dataCart.item_count === goldQty) {
      freeShippingMessage?.classList.add('hide');
    } else {
      freeShippingMessage?.classList.remove('hide');
    }

  }).then(finishGoldCartCheck, finishGoldCartCheck);
}


/* ---------- WATCH CART CHANGES (FIX FOR DELETE ISSUE) ---------- */

// Native change fires after cart lines are rebuilt; Rebuy covers its own
// add/remove/quantity changes. Unrelated page mutations need no cart request.
document.addEventListener('theme:cart:change', scheduleGoldCartCheck);
document.addEventListener('theme:cart:open', scheduleGoldCartCheck);
document.addEventListener('rebuy:cart.change', scheduleGoldCartCheck);


/* ---------- INITIAL RUN ---------- */
goldCartCheckTimer = setTimeout(checkCartData, 1000);





// document.addEventListener(
//   "click",
//   async function (e) {

//     const plusBtn = e.target.closest(".cart__quantity-plus");
//     const minusBtn = e.target.closest(".cart__quantity-minus");

//     if (!plusBtn && !minusBtn) return;

//     const cartItem = e.target.closest(".cart__item");

//     if (!cartItem) return;

//     const isGoldProduct =
//       cartItem.dataset.goldProduct === "true";

//     // only custom logic for gold products
//     if (!isGoldProduct) return;

//     // stop default theme quantity logic
//     e.preventDefault();
//     e.stopPropagation();
//     e.stopImmediatePropagation();

//     const qtyInput =
//       cartItem.querySelector(".cart__quantity-field");

//     const lineKey = qtyInput.dataset.id;

//     let currentQty = parseInt(qtyInput.value) || 0;

//     /* -----------------------------------
//        CALCULATE TOTAL GOLD QTY IN CART
//     ----------------------------------- */

//     let totalGoldQty = 0;

//     document.querySelectorAll(".cart__item").forEach(item => {

//       const isGold =
//         item.dataset.goldProduct === "true";

//       if (!isGold) return;

//       const qty = parseInt(
//         item.querySelector(".cart__quantity-field")?.value
//       ) || 0;

//       totalGoldQty += qty;

//     });

//     /* -----------------------------------
//        STEP LOGIC
//        odd  -> 1
//        even -> 2
//     ----------------------------------- */

//     const step =
//       totalGoldQty % 2 === 0 ? 2 : 1;

//     let newQty = currentQty;

//     /* -----------------------------------
//        PLUS
//     ----------------------------------- */

//     if (plusBtn) {
//       newQty = currentQty + step;
//     }

//     /* -----------------------------------
//        MINUS
//     ----------------------------------- */

//     if (minusBtn) {

//       newQty = currentQty - step;

//       // remove product if qty below 0
//       if (newQty < 0) {
//         newQty = 0;
//       }

//     }

//     try {

//       // instant UI update
//       qtyInput.value = newQty;

//       const response = await fetch("/cart/change.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           id: lineKey,
//           quantity: newQty,
//         }),
//       });

//       const cart = await response.json();

//       console.log("Updated cart", cart);

//       // refresh cart drawer
//       window.cart.getCart();

//     } catch (error) {
//       console.error("Cart update error:", error);
//     }

//   },
//   true
// );



